import { render, staticRenderFns } from "./merchantClassInfo.vue?vue&type=template&id=3daf5591&scoped=true&"
import script from "./merchantClassInfo.vue?vue&type=script&lang=js&"
export * from "./merchantClassInfo.vue?vue&type=script&lang=js&"
import style0 from "./merchantClassInfo.vue?vue&type=style&index=0&id=3daf5591&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3daf5591",
  null
  
)

export default component.exports